<template>
    <div class="am-select-range">
      <div class="am-select-range-header">
        <span>Select Printing Range</span>
      </div>
      <div class="am-select-range-content">
        <span>Pages: <input type="text" v-model="pages" placeholder="1-10"></span>
      </div>
      <div class="am-blue-border"></div>
      <div class="am-buttons">
        <button type="button" class="btn btn-secondary btn-xs" @click="closeModal">Cancel</button>
        <button type="button" class="btn btn-primary btn-xs" @click="onSubmit">Submit</button>
      </div>
    </div>
</template>

<script>
    export default {
        name: "SelectRange",
        data() {
          return {
            pages:'',
          }
        },

        methods: {
          closeModal: function() {
            this.$store.dispatch('events/fireEvent', { name: 'close-printing-range-selection', data: null })
          },
          onSubmit: function() {
            this.$store.dispatch('events/fireEvent', { name: 'select-printing-range', data: this.pages });
            this.closeModal();
          }
        }
    }
</script>

<style scoped>
.am-select-range {
  width: 450px;
  background-color: whitesmoke;
  overflow: hidden;
}
.am-select-range-header {
  height: 35px;
  background-color: #428bca;
  padding: 10px;
  top: 0;
  color: white;
  font-weight: 700;
}
.am-blue-border {
  display: block;
  width: 100%;
  border-top: 1px solid #4297d7;
  margin-top: 10px;
}

.am-buttons {
  bottom: 0;
  padding: 9px 7px 10px 0px;
  float: right;
}
.am-select-range-content {
  padding: 20px;
  height: 60px;
}
</style>
